/** Public brand mark URLs (color tile + mono symbol). */
export const BRAND_LOGO_COLOR = `${process.env.PUBLIC_URL || ''}/nuevologo.svg`;
export const BRAND_LOGO_MONO = `${process.env.PUBLIC_URL || ''}/nuevologo_mono.svg`;
